<template>
    <div class="uni-body pages-verify-verify" @touchmove.prevent>
      <div class="uni-app--maxwidth">
        <div class="uni-page" data-page="pages/verify/verify">
          <div class="uni-page-wrapper">
            <div class="uni-page-body">
              <div class="verify flex-column align-items-center" style="padding-top: 68px;">
                <div class="font-bolder" style="font-size: 29px;">安全验证</div>
                <div class="mt-xs" style="font-size: 20px;">请完成下列安全验证后继续</div>

                <div class="footer2 flex align-items-center">
                  <div class="h-100 slider-box flex-center-center">
                    <div class="slider flex-center-center" @mousedown="startSlide" @touchstart="startSlide" :style="{ transform: `translateX(${sliderPosition}px)` }">
                        <img style="width: 31px;height: 24px;" src="data:image/png;base64,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">
                    </div>
                    <div style="font-size: 16px;margin-left: 10px;">向右滑动解锁</div>
                </div>

                    </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        isSliding: false,
        sliderPosition: 0,
        isUnlocked: false,
        unlockMessage: '解锁成功！',
      };
    },
    created() {
      this.$parent.footer("user", false);
    },
    methods: {
      startSlide(event) {
        this.isSliding = true;
        const startX = event.type === 'mousedown' ? event.clientX : event.touches[0].clientX;
        const containerWidth = this.$el.querySelector('.footer2').offsetWidth; // 获取容器宽度
        const sliderWidth = this.$el.querySelector('.slider').offsetWidth; // 获取滑块宽度
        const maxRight = containerWidth - 1.3*sliderWidth;
  
        // 阻止默认事件，防止页面滚动
        event.preventDefault();
  
        const slide = (event) => {
          if (!this.isSliding) return;
  
          const currentX = event.type === 'mousemove' ? event.clientX : event.touches[0].clientX;
          let offsetX = currentX - startX;
  
          if (offsetX < 0) offsetX = 0; // Prevent sliding left
          if (offsetX > maxRight) offsetX = maxRight; // Prevent sliding beyond the right
  
          this.sliderPosition = offsetX;
  
          if (offsetX === maxRight) {
                this.unlock();
          }
        };
  
        const endSlide = () => {
          this.isSliding = false;
          document.removeEventListener('mousemove', slide);
          document.removeEventListener('touchmove', slide);
          document.removeEventListener('mouseup', endSlide);
          document.removeEventListener('touchend', endSlide);
          this.resetSlider();
        };
  
        document.addEventListener('mousemove', slide);
        document.addEventListener('touchmove', slide);
        document.addEventListener('mouseup', endSlide);
        document.addEventListener('touchend', endSlide);
      },
      unlock() {
        this.isUnlocked = true;
        this.sliderPosition = this.$el.querySelector('.footer2').offsetWidth - this.$el.querySelector('.slider').offsetWidth;
        this.$router.push("/index");     
      },
      resetSlider() {
        if (!this.isUnlocked) {
          this.sliderPosition = 0;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  * { margin: 0; -webkit-tap-highlight-color: transparent; }
  .uni-page-body { background-color: var(--UI-BG-0); color: var(--UI-FG-0); }
  .uni-page-wrapper { display: block; height: 100%; position: relative; }
  .uni-page-body { display: block; box-sizing: border-box; width: 100%; }
  .uni-page { display: block; width: 100%; height: 100%; }
  .uni-image { width: 320px; height: 240px; display: inline-block; overflow: hidden; position: relative; }
  .uni-image > div, .uni-image > img { width: 100%; height: 100%; }
  .uni-image > img { -webkit-touch-callout: none; -webkit-user-select: none; -moz-user-select: none; display: block; position: absolute; top: 0; left: 0; opacity: 0; }
  .uni-movable-area { display: block; position: relative; width: 10px; height: 10px; }
  .uni-movable-view { display: inline-block; width: 10px; height: 10px; top: 0; left: 0; position: absolute; cursor: grab; }
  .uni-resize-sensor, .uni-resize-sensor > div { position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; }
  .uni-resize-sensor { display: block; z-index: -1; visibility: hidden; -webkit-animation: once-show 1ms; animation: once-show 1ms; }
  .uni-resize-sensor > div > div { position: absolute; left: 0; top: 0; }
  .uni-resize-sensor > div:first-child > div { width: 100000px; height: 100000px; }
  .uni-resize-sensor > div:last-child > div { width: 200%; height: 200%; }
  .uni-view { display: block; }
  ::-webkit-scrollbar { display: none; width: 0!important; height: 0!important; -webkit-appearance: none; background: transparent; }
  * { margin: 0; padding: 0; box-sizing: border-box; -webkit-touch-callout: none; -khtml-user-select: none; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; -webkit-user-drag: none; }
  .uni-page-body { height: 100%; background-color: #f6f7fb!important; }
  .h-100 { height: 100%; }
  .mt-xs { margin-top: 6px; }
  .flex { display: flex; }
  .flex-column { display: flex; flex-direction: column; }
  .flex-center-center { display: flex; justify-content: center; align-items: center; }
  .flex-1 { flex: 1; }
  .align-items-center { align-items: center!important; }
  .font-bolder { font-weight: 800; }
  .text-align-justify { text-align: justify; }
  body.pages-verify-verify .uni-page-body { background-color: #f6f7fb; }
  .verify { width: 100%; height: 100vh; background: url(/img/verify-bg.0a57f0eb.png) no-repeat; background-size: cover; color: #fff; }
  .footer2 { width: 295px; height: 70px; padding: 0 9px; border: 3px solid #d4e8ff; border-radius: 36px; position: fixed; bottom: 74px; }
  .footer2 .slider-box {height: 100%; }
  .footer2 .slider { width: 81px; height: 49px; background-color: #fff; border-radius: 20px; }
  .footer2 .slider .uni-image { width: 31px; height: 24px; }
  .footer2 .slider-text { text-align: right; font-size: 17px; }
  @-webkit-keyframes once-show { 0% { top: 0; } }
  @keyframes once-show { 0% { top: 0; } }
  </style>
  